var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.86677 0.750004C5.82272 0.673702 5.75929 0.610395 5.6829 0.566493C5.60651 0.522591 5.51988 0.499654 5.43177 0.500004H0.56677C0.47947 0.500963 0.393943 0.524765 0.318697 0.569041C0.243452 0.613317 0.181111 0.676523 0.137877 0.752372C0.0946431 0.828221 0.0720231 0.914069 0.0722676 1.00137C0.072512 1.08868 0.0956124 1.1744 0.13927 1.25L2.57177 5.2675C2.61634 5.34098 2.67909 5.40172 2.75397 5.44388C2.82885 5.48604 2.91334 5.50819 2.99927 5.50819C3.0852 5.50819 3.16969 5.48604 3.24457 5.44388C3.31945 5.40172 3.3822 5.34098 3.42677 5.2675L5.85927 1.25C5.9043 1.17465 5.9287 1.08878 5.93002 1.00101C5.93133 0.913239 5.90952 0.82667 5.86677 0.750004Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.d7f8aca8.svg";
export { ForwardRef as ReactComponent };